import styled from "styled-components";

export const Box = styled.div`
  padding: .5rem;
  text-align: center;
  display: block;
  margin-right: 4px;
`;
export const Settings = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
`;
export const Telefone = styled.div`
  border-radius: 5px;
  text-align: center;
  background-color:  ${props => props.bgColor};
  color: ${props => props.bgColor !== "#0000001a" ? "#ffffff" : "rgba(0,0,0,0.9)"}; 
  padding: 0.7rem 1.2rem;
  font-weight: bold;
`;
export const ActionButton = styled.div`
  color: ${props => props.hasWhatsapp ? "#27b360" : "#ffffff"};
  border-radius: 5px;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  background-color: ${props => props.bgColor};
  margin: 4px;  
  svg {
    width: ${props => props.hasWhatsapp ? ".8em" : ".6em"} !important;
  }
`;


// WEBPACK FOOTER //
// ./src/components/PequisadorTelefones/styles.js